var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-badge',{staticClass:"ml-1 mr-8",attrs:{"color":"blue","content":"PRO"}})}
var staticRenderFns = []

export { render, staticRenderFns }